(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var canHover = matchMedia('(hover: hover)').matches;
    var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var observer = 'IntersectionObserver' in window && new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { e.isIntersecting ? play(e.target) : e.target.pause(); });
    }, { threshold: 0.25 });

    function play(video) {
      video.muted = true; // browsers only allow autoplay when muted
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    function init(section) {
      if (section.dataset.psReady) return;
      section.dataset.psReady = 'true';
      var track = section.querySelector('.product-scroll__track');
      var prev = section.querySelector('.product-scroll__arrow--prev');
      var next = section.querySelector('.product-scroll__arrow--next');
      if (!track || !prev || !next) return;

      function page(dir) {
        var item = track.querySelector('.product-scroll__item');
        if (item) track.scrollBy({ left: dir * (item.offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 0)) });
      }
      function update() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }
      prev.addEventListener('click', function () { page(-1); });
      next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();

      section.querySelectorAll('video[data-ps-video]').forEach(function (video) {
        var link = video.closest('.product-scroll__link');
        if (video.dataset.psVideo === 'hover' && canHover && link) {
          link.addEventListener('mouseenter', function () { play(video); });
          link.addEventListener('mouseleave', function () { video.pause(); video.currentTime = 0; });
        } else if (!reduceMotion) {
          // Autoplay videos (and hover videos on touch devices) play only while on screen
          observer ? observer.observe(video) : play(video);
        }
      });
    }

    function initAll() { document.querySelectorAll('.product-scroll').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
